//import { languages } from '../../features/library/applicationForm/SelectData/languages';
import firebase from '../config/firebase';

const db = firebase.firestore();

export function dataFromSnapshot(snapshot) {
  if (!snapshot.exists) return undefined;
  const data = snapshot.data();

  for (const prop in data) {
    if (data.hasOwnProperty(prop)) {
      if (data[prop] instanceof firebase.firestore.Timestamp) {
        data[prop] = data[prop].toDate();
      }
    }
  }

  return {
    ...data,
    id: snapshot.id,
  };
}

export function fetchApplicationsFromFirestore(
  language,
  level,
  media_type,
  limit = 1,
  lastDocSnapshot = null,
  showGeneric
) {
  let appRef = db.collection('applications');
  appRef = appRef
    .orderBy('rating_avg_desc')
    .orderBy('rating_score_desc')
    .startAfter(lastDocSnapshot)
    .where('status', '==', 'Published')
    .limit(limit);

  let search = '';
  let searchAnyLanguage = '';
  let searchAnyLevel = '';
  let searchAnyLanguageAnyLevel = '';

  if (level && level.length > 0 && level !== 'All') {
    searchAnyLevel = search + 'any';
    searchAnyLanguageAnyLevel = search + 'any';
    search += level.toLowerCase();
  }

  if (media_type && media_type.length > 0 && media_type !== 'All') {
    if (search !== '') search += '|';
    search += media_type.toLowerCase();
    if (searchAnyLevel !== '') searchAnyLevel += '|' + media_type.toLowerCase();
    if (searchAnyLanguageAnyLevel !== '')
      searchAnyLanguageAnyLevel += '|' + media_type.toLowerCase();
  }

  if (language && language.length > 0 && language !== 'All') {
    if (searchAnyLevel !== '')
      searchAnyLevel = language.toLowerCase() + '|' + searchAnyLevel;

    if (searchAnyLanguageAnyLevel !== '')
      searchAnyLanguageAnyLevel = 'any|' + searchAnyLanguageAnyLevel;

    if (search !== '') search = '|' + search;

    searchAnyLanguage = 'any' + search;
    search = language.toLowerCase() + search;
  }

  if (
    search.length > 0 &&
    (searchAnyLanguage.length > 0 ||
      searchAnyLevel.length > 0 ||
      searchAnyLanguageAnyLevel.length > 0)
  ) {
    let searchArray = [];
    searchArray.push(search);
    if (
      searchAnyLanguage.length > 0 &&
      searchAnyLanguage !== 'any' &&
      showGeneric
    )
      searchArray.push(searchAnyLanguage);
    if (searchAnyLevel.length > 0 && searchAnyLevel !== 'any')
      searchArray.push(searchAnyLevel);

    appRef = appRef.where('tags', 'array-contains-any', searchArray);
  } else if (search.length > 0) {
    console.log({ search });
    appRef = appRef.where('tags', 'array-contains', search);
  }

  return appRef;
}

export function fetchAllApplicationsFromFirestore() {
  return db.collection('applications');
}

export function fetchAllBrokenLinksFromFirestore() {
  return db.collection('applications').orderBy('brokenLink');
}

export function updateAllTags() {
  db.collection('applications')
    .get()
    .then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        const languages = doc.get('language');
        const levels = doc.get('level');
        const media_types = doc.get('media_type');

        let tags = [];
        languages.forEach((lang) => {
          lang = lang.toLowerCase();
          let tag = lang;
          tags.push(tag);
          levels.forEach((lev) => {
            lev = lev.toLowerCase();
            tags.push(lev);
            tag = lang + '|' + lev;
            tags.push(tag);
            media_types.forEach((med) => {
              med = med.toLowerCase();
              tags.push(med);
              tag = lev + '|' + med;
              tags.push(tag);
              tag = lang + '|' + lev + '|' + med;
              tags.push(tag);
              tag = lang + '|' + med;
              tags.push(tag);
            });
          });
        });

        doc.ref.update({
          tags: tags,
        });
      });
    });
}

export function updateScoresFromReviews() {
  db.collection('applications')
    .get()
    .then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        const application_id = doc.get('id');
        const rating_user = Math.round(doc.get('rating_user'));
        const rating_score = Math.round(doc.get('rating_score'));

        const Stars_5 = doc.get('Stars_5');
        const Stars_4 = doc.get('Stars_4');
        const Stars_3 = doc.get('Stars_3');
        const Stars_2 = doc.get('Stars_2');
        const Stars_1 = doc.get('Stars_1');
        const Sum_stars = Stars_5 + Stars_4 + Stars_3 + Stars_2 + Stars_1;
        const Stars_total =
          Stars_5 * 5 + Stars_4 * 4 + Stars_3 * 3 + Stars_2 * 2 + Stars_1 * 1;

        const diff_stars = rating_user - Sum_stars;
        const diff = rating_score - Stars_total;

        if (rating_user !== Sum_stars) {
          console.log({
            application_id,
            diff_stars,
            rating_score,
            Stars_total,
            diff,
          });
        }
      });
    });

  // db.collection('reviews')
  //   .get()
  //   .then(function (querySnapshot) {
  //     querySnapshot.forEach(async function (doc) {
  //       let application_id = doc.get('application_id');
  //       let score = doc.get('star_rating');
  //       if (application_id !== '') {
  //         //console.log({ application_id, score });
  //         switch (score) {
  //           case '5':
  //             await db
  //               .collection('applications')
  //               .doc(application_id)
  //               .update({
  //                 Stars_5: firebase.firestore.FieldValue.increment(1),
  //               });
  //             break;
  //           case '4':
  //             await db
  //               .collection('applications')
  //               .doc(application_id)
  //               .update({
  //                 Stars_4: firebase.firestore.FieldValue.increment(1),
  //               });
  //             break;
  //           case '3':
  //             await db
  //               .collection('applications')
  //               .doc(application_id)
  //               .update({
  //                 Stars_3: firebase.firestore.FieldValue.increment(1),
  //               });
  //             break;
  //           case '2':
  //             console.log(application_id);
  //             await db
  //               .collection('applications')
  //               .doc(application_id)
  //               .update({
  //                 Stars_2: firebase.firestore.FieldValue.increment(1),
  //               });
  //             break;
  //           case '1':
  //             await db
  //               .collection('applications')
  //               .doc(application_id)
  //               .update({
  //                 Stars_1: firebase.firestore.FieldValue.increment(1),
  //               });
  //             break;
  //           default:
  //             //console.log('No match : ' + score);
  //             break;
  //         }
  //         console.log("Pinch me, I'm done!");
  //       }
  //     });
  //   });
}

export function setAllDescScores() {
  db.collection('applications')
    .get()
    .then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        let score = doc.get('rating_score') || 0;
        let user = doc.get('rating_user') || 0;
        let avg = doc.get('rating_avg') || 0;

        if (score > 1000) {
          score = 100000 - score;
        }
        if (user > 1000) {
          user = 100000 - user;
        }
        if (avg > 1000) {
          avg = 100000 - avg;
        }

        let score_desc = doc.get('rating_score_desc') || 0;
        let user_desc = doc.get('rating_user_desc') || 0;
        let avg_desc = doc.get('rating_avg_desc') || 0;

        if (score_desc < 1000) {
          score_desc = 100000 - score_desc;
        }

        if (user_desc < 1000) {
          user_desc = 100000 - user_desc;
        }
        if (avg_desc < 1000) {
          avg_desc = 100000 - avg_desc;
        }

        doc.ref.update({
          rating_score: score,
          rating_user: user,
          rating_avg: avg,
          rating_score_desc: score_desc,
          rating_user_desc: user_desc,
          rating_avg_desc: avg_desc,
        });
        // console.log({ new_score, new_user, new_avg });
      });
    });
}
export function setAllToDraft() {
  // db.collection('applications')
  //   .get()
  //   .then(function (querySnapshot) {
  //     let x = 0;
  //     querySnapshot.forEach(function (doc) {
  //       x += 1;
  //       let tags = [];
  //       const language = doc.get('language');
  //       const level = doc.get('level');
  //       const media_type = doc.get('media_type');
  //       const id = doc.id;
  //       const title = doc.get('title');
  //       tags = [];
  //       language.map((lang) => {
  //         tags.push(lang.toLowerCase());
  //         level.map((lev) => {
  //           tags.push(lev.toLowerCase());
  //           tags.push(lang.toLowerCase() + '|' + lev.toLowerCase());
  //           media_type.map((media) => {
  //             tags.push(media.toLowerCase());
  //             tags.push(lang.toLowerCase() + '|' + media.toLowerCase());
  //             tags.push(
  //               lang.toLowerCase() +
  //                 '|' +
  //                 lev.toLowerCase() +
  //                 '|' +
  //                 media.toLowerCase()
  //             );
  //           });
  //         });
  //         //
  //       });
  //       //if (tags.length >= 200) {
  //       console.log({ title, id, tags });
  //       doc.ref.update({
  //         tags: tags,
  //       });
  //       //}
  //       tags = [];
  //     });
  //     console.log(x);
  //   });
}

export function listenToApplicationFromFirestore(applicationId) {
  return db.collection('applications').doc(applicationId);
}

export function addApplicationToFirestore(application) {
  const user = firebase.auth().currentUser;
  return db.collection('applications').add({
    ...application,
    author: user.displayName,
    authorId: user.uid,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
}

export async function getAppIdFromSlug(slug) {
  try {
    await db
      .collection('applications')
      .where('slug', '==', slug)
      .limit(1)
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          return doc.id;
        });
      });
  } catch (error) {
    console.log(error);
  }
}

export function getAffiliateURLFromSlug(slug) {
  return db.collection('applications').where('slug', '==', slug);
}

export function addReviewToFirebase(review) {
  return db.collection('reviews').add({ ...review });
}

export function updateApplicationInFirestore(application) {
  return db.collection('applications').doc(application.id).update(application);
}

export function deleteApplicationInFirestore(applicationId) {
  return db.collection('applications').doc(applicationId).delete();
}

export function setUserProfileData(user) {
  return db
    .collection('users')
    .doc(user.uid)
    .set({
      displayName: user.displayName,
      email: user.email,
      photoURL: user.photoURL || null,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    });
}

export function getUserProfile(userId) {
  return db.collection('users').doc(userId);
}

export async function updateUserProfile(profile) {
  const user = firebase.auth().currentUser;
  try {
    if (user.displayName !== profile.displaName) {
      await user.updateProfile({
        displayName: profile.displayName,
      });
    }
    return await db.collection('users').doc(user.uid).update(profile);
  } catch (error) {
    throw error;
  }
}

export async function addToFavorites(application) {
  const user = firebase.auth().currentUser;
  try {
    const userRef = db.collection('users').doc(user.uid);
    await userRef.collection('favorites').add({
      applicationId: application.id,
      title: application.title,
      //photoURL: application.photoURL,
      description: application.intro,
    });
    return await userRef.update({
      favorites: firebase.firestore.FieldValue.arrayUnion(application.id),
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function removeFromFavorites(applicationId, favoriteId) {
  const user = firebase.auth().currentUser;
  try {
    const userRef = db.collection('users').doc(user.uid);
    const snapshot = await userRef
      .collection('favorites')
      .where('applicationId', '==', applicationId)
      .limit(1)
      .get();
    const favorites = snapshot.docs.map((doc) => dataFromSnapshot(doc));
    if (favorites && favorites[0]) {
      userRef.collection('favorites').doc(favorites[0]['id']).delete();
    } else {
      console.log('not deleted');
    }

    //await userRef.collection('favorites').doc(favoriteId).delete();
    return await userRef.update({
      favorites: firebase.firestore.FieldValue.arrayRemove(applicationId),
    });
  } catch (error) {
    throw error;
  }
}

export async function updateUserProfilePhoto(downloadURL, filename) {
  const user = firebase.auth().currentUser;
  const userDocRef = db.collection('users').doc(user.uid);
  try {
    const userDoc = await userDocRef.get();
    if (!userDoc.data().photoURL) {
      await db.collection('users').doc(user.uid).update({
        photoURL: downloadURL,
      });
      await user.updateProfile({
        photoURL: downloadURL,
      });
    }
    return await db.collection('users').doc(user.uid).collection('photos').add({
      name: filename,
      url: downloadURL,
    });
  } catch (error) {
    throw error;
  }
}

export function getUserPhotos(userUid) {
  return db.collection('users').doc(userUid).collection('photos');
}

export async function setMainPhoto(photo) {
  const user = firebase.auth().currentUser;

  try {
    await db.collection('users').doc(user.uid).update({
      photoURL: photo.url,
    });
    return await user.updateProfile({
      photoURL: photo.url,
    });
  } catch (error) {
    throw error;
  }
}

export function deletePhotoFromCollection(photoID) {
  const userUid = firebase.auth().currentUser.uid;
  return db
    .collection('users')
    .doc(userUid)
    .collection('photos')
    .doc(photoID)
    .delete();
}

export async function updateApplicationPhoto(
  downloadURL,
  filename,
  applicationId
) {
  const appDocRef = db.collection('applications').doc(applicationId);
  try {
    const appDoc = await appDocRef.get();
    if (!appDoc.data().photoURL) {
      await db.collection('applications').doc(applicationId).update({
        photoURL: downloadURL,
      });
    }
    return await db
      .collection('applications')
      .doc(applicationId)
      .collection('photos')
      .add({
        name: filename,
        url: downloadURL,
      });
  } catch (error) {
    throw error;
  }
}

export function getApplicationPhotos(application) {
  if (!application || application.id === undefined) return null;
  const photos = db
    .collection('applications')
    .doc(application.id)
    .collection('photos');
  return photos;
}

export function getApplicationPhotosById(applicationId) {
  const photos = db
    .collection('applications')
    .doc(applicationId)
    .collection('photos');
  return photos;
}
export async function setMainApplicationPhoto(applicationId, photo) {
  try {
    return await db
      .collection('applications')
      .doc(applicationId)
      .update({ photoURL: photo.url });
  } catch (error) {
    throw error;
  }
}

export function deleteApplicationPhotoFromCollection(applicationId, photoId) {
  return db
    .collection('applications')
    .doc(applicationId)
    .collection('photos')
    .doc(photoId)
    .delete();
}

export function getApplication(applicationId) {
  return db.collection('applications').doc(applicationId);
}

export function getApplicationBySlug(slug) {
  let appRef = db.collection('applications');
  appRef = appRef.where('slug', '==', slug).limit(1);
  return appRef;
}

export function getReviewsByApplicationId(appID) {
  let appRef = db.collection('reviews');
  appRef = appRef.where('application_id', '==', appID).where('title', '!=', '');
  return appRef;
}

export async function reportBrokenLink(appId) {
  const user = firebase.auth().currentUser;
  let displayName, userUid;
  if (user && user.uid) {
    userUid = user.uid;
    displayName = user.displayName;
  } else {
    userUid = 'anonymous';
    displayName = 'anonymous';
  }
  console.log(displayName);
  return await db
    .collection('applications')
    .doc(appId)
    .update({
      brokenLinkLastReported: new Date(),
      brokenLink: firebase.firestore.FieldValue.arrayUnion({
        by: userUid,
        name: displayName,
      }),
    });
}
